import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom'; // Importação do Link
import Api from '../../Api';

interface Dados {
    ano?: string;
    data?: string;
    nome?: string;
    texto?: string;
    arquivo?: string;
    obs?: string;
}

const DetalhesTributario: React.FC = () => {
    const [dados, setDados] = useState<Dados | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const { id } = useParams();

    useEffect(() => {
        const fetchDados = async () => {
            try {
                setIsLoading(true);
                const response = await Api.get<Dados>(`tributario/${id}`);
                setDados(response.data);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching ata:', error);
                setIsLoading(false);
            }
        };

        fetchDados();
    }, [id]);

    return (
        <div className="container mx-auto mt-5 mb-5">
            {isLoading ? (
                <div className="flex justify-center">
                    <div className="loading-spinner"></div>
                </div>
            ) : (
                <div>
                    <h2 className="text-center text-2xl font-bold mb-4">Detalhes do Código Tributário</h2>
                    <div className="border border-gray-400 p-4">
                        {dados?.ano && <p><strong>Ano:</strong> {dados.ano}</p>}
                        {dados?.data && <p><strong>Data:</strong> {dados.data}</p>}
                        {dados?.nome && <p><strong>Nome:</strong> {dados.nome}</p>}
                        {dados?.texto && <p><strong>Texto:</strong> <div dangerouslySetInnerHTML={{ __html: dados.texto }} /></p>}
                        {dados?.arquivo && (
                            <p><strong>Arquivo Contrato:</strong> <button
                                className="bg-blue-500 text-white py-1 px-2 rounded ml-2 text-sm"
                                onClick={() => window.open(dados.arquivo, "_blank")}
                            >
                                Visualizar contrato
                            </button></p>
                        )}
                        {dados?.obs && <p><strong>Obs:</strong> {dados.obs}</p>}
                    </div>

                    <div className="mt-4">
                        <Link to="/tributario" className="bg-blue-500 text-white py-2 px-4 rounded">Voltar</Link>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DetalhesTributario;
